import { atom, selectorFamily } from "recoil";
import type { ClipStatusTimeline } from "MVVM/Components/ClipStatus/@types";
import { persistAtom } from "./persist";

export const InFlightClipsAtom = atom<ClipStatusTimeline[]>({
  key: "InFlightClips_V0.1",
  default: [],
});

/**
 * One clip's timeline. Subscribing through this instead of the atom keeps a
 * grid of finished cards from re-rendering on every poll: they resolve to
 * undefined each tick, and recoil skips subscribers whose value is unchanged.
 * A timeline's `clipId` is the clip's shareId.
 */
export const InFlightTimelineSelector = selectorFamily<
  ClipStatusTimeline | undefined,
  { trackId?: string; shareId?: string }
>({
  key: "InFlightTimeline_V0.1",
  get:
    ({ trackId, shareId }) =>
    ({ get }) => {
      if (!trackId && !shareId) return undefined;
      return get(InFlightClipsAtom).find(
        (timeline) =>
          (!!trackId && timeline.trackId === trackId) ||
          (!!shareId && timeline.clipId === shareId),
      );
    },
});

export const PollingActiveAtom = atom<boolean>({
  key: "PollingActive_V0.1",
  default: false,
});

export const TrayUIAtom = atom<{ expanded: boolean; pinnedTrackId?: string }>({
  key: "TrayUI_V0.1",
  default: { expanded: false },
});

export const DismissedTerminalsAtom = atom<Record<string, number>>({
  key: "DismissedTerminals_V0.1",
  default: {},
  effects_UNSTABLE: [persistAtom],
});

export const ExpandedCardsAtom = atom<Record<string, boolean>>({
  key: "ExpandedCards_V0.1",
  default: {},
});

export const PulseKickAtom = atom<number>({
  key: "PulseKick_V0.1",
  default: 0,
});
